import { requestFunnel } from '@/application/api';
import { authenticationService } from '@/application/services/api-clients/login-service';

const getAuthorizationOptions = () => ({ headers: authenticationService.authHeader() });

export const createHelpTicket = async (subject, text) => {
  const result = await requestFunnel.post('help-tickets', { subject, text }, getAuthorizationOptions());
  return result.data;
};

export const addMessageToHelpTicket = async (helpTicketId, text, closeTicket) => {
  const result = await requestFunnel.patch(`help-tickets/${helpTicketId}`, { text, closeTicket }, getAuthorizationOptions());
  return result.data;
};

export const getHelpTickets = async () => {
  const result = await requestFunnel.get('help-tickets', getAuthorizationOptions());
  return result.data;
};

export const closeHelpTicket = async helpTicketId => {
  const result = await requestFunnel.patch(`help-tickets/${helpTicketId}/close`, {}, getAuthorizationOptions());
  return result.data;
};
export const closeHelpTicketWithoutEmail = async helpTicketId => {
  const result = await requestFunnel.patch(`help-tickets/${helpTicketId}/closeWithoutEmail`, {}, getAuthorizationOptions());
  return result.data;
};

export const getSubjectsDictionary = async () => {
  const result = await requestFunnel.get('help-tickets/subjectsDictionary', getAuthorizationOptions());
  return result.data;
};
